'use client'

import { usePathname } from 'next/navigation'
import PreferencesModal from './PreferencesModal'
import { useAuth } from '@/hooks/use-auth'
import { Dictionary } from '@/dictionaries'

export default function PreferencesModalWrapper({ dict }: { dict: Dictionary }) {
  const pathname = usePathname()
  const { isAuthenticated } = useAuth()
  
  const lang = pathname?.split('/')[1] || 'es'
  
  if (!isAuthenticated) {
    return null
  }
  
  return <PreferencesModal dict={dict} lang={lang} />
}

